import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SessionTimerStoreState {
    expiryTime: number | null;
    sessionMaxInterval: number | null;
    remainingTime: number | null;
    isAlertSession: boolean;
    isExpiredSession: boolean;

    setExpiryTime: (time: number | null) => void;
    setSessionMaxInterval: (interval: number | null) => void;
    setRemainingTime: (second: number | null) => void;
    setIsAlertSession: (value: boolean) => void;
    setIsExpireSession: (value: boolean) => void;

    alertSessionTimer: () => void;
    expireSessionTimer: () => void;

    clearTime: () => void;
}

/**
 * 세션타이머 store
 */
export const useSessionTimerStore = create<SessionTimerStoreState>()(
    persist(
        (set) => ({
            // 세션 타이머 만료 시각
            expiryTime: null,
            sessionMaxInterval: null,
            remainingTime: null,
            isAlertSession: false,
            isExpiredSession: false,

            // 세션 타임 설정
            setExpiryTime: (time) => set({ expiryTime: time }),
            setSessionMaxInterval: (interval) => set({ sessionMaxInterval: interval }),
            setRemainingTime: (second) => set({ remainingTime: second }),
            setIsAlertSession: (value) => set({ isAlertSession: value }),
            setIsExpireSession: (value) => set({ isExpiredSession: value }),

            // 세션 안내 및 만료처리
            alertSessionTimer: () => set({ isAlertSession: true, isExpiredSession: false }),
            expireSessionTimer: () =>
                set({ expiryTime: null, isAlertSession: false, isExpiredSession: true }),

            // 세션 타이머 클리어
            clearTime: () => set({ expiryTime: null, remainingTime: null }),
        }),
        {
            name: 'session-time-storage', // 세션스토리지에 저장될 키 이름
            storage: createJSONStorage(() => sessionStorage),
            partialize: (state) => ({
                expiryTime: state.expiryTime,
                sessionMaxInterval: state.sessionMaxInterval,
            }),
        },
    ),
);
